// English translations, dot-namespaced; add new keys here AND in fr.js.
const en = {
  // --- Common UI strings ---------------------------------------------------
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.deactivate': 'Deactivate',
  'common.activate': 'Activate',
  'common.search': 'Search',
  'common.loading': 'Loading...',
  'common.actions': 'Actions',
  'common.status': 'Status',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.showInactive': 'Show inactive',
  'common.noEntries': 'No entries',
  'common.saving': 'Saving...',
  'common.required': 'required',
  'common.code': 'Code',
  'common.name': 'Name',
  'common.description': 'Description',
  'common.welcome': 'Welcome',
  'common.logout': 'Secure Logout',
  'common.guest': 'Guest',
  'common.appName': 'RestoBoxx',
  'common.currentLocation': 'Current location',
  'common.showSidebar': 'Show sidebar',
  'common.yes': 'Yes',
  'common.no': 'No',
  /* The signed-in person's menu, behind the avatar at the end of the header. */
  'userMenu.preferences': 'Preferences',
  'userMenu.switchOutlet': 'Switch outlet',
  'userMenu.noOutlets': 'No other outlets',
  /* Header icon controls, beside the bell and the theme switch. */
  'header.help': 'Help & InTutor',
  'header.fullscreen': 'Full screen',
  'header.exitFullscreen': 'Exit full screen',
  /* Type-to-find over the whole navigation, in the header. */
  'search.menus': 'Search menus…',
  'search.noMatch': 'No menu matches “{q}”.',
  'common.saved': 'Saved',
  'common.savedDescription': 'Your changes have been applied.',
  'common.saveFailed': 'Save failed',

  // --- Language switcher ---------------------------------------------------
  'language.english': 'English',
  'language.french': 'French',
  'language.label': 'Language',

  // --- Sidebar / navigation ------------------------------------------------
  'nav.overview': 'Overview',
  'nav.dashboard': 'Dashboard',
  'nav.reports': 'Reports',
  'nav.menu': 'Menu',
  'nav.menus': 'Menus',
  'nav.allMenus': 'All Menus',
  'nav.createMenu': 'Create Menu',
  'nav.allDishes': 'All Menu Items',
  'nav.addDish': 'Add Dish',
  'nav.orders': 'Orders',
  'nav.manageOrders': 'Create New Order',
  'nav.inventory': 'Inventory',
  'nav.records': 'Records',
  'nav.itemTracking': 'Item Tracking',
  'nav.purchase': 'Purchase',
  'nav.bar': 'Bar',
  'nav.barInventory': 'Bar Inventory',
  'nav.liquorManagement': 'Liquor Management',
  'nav.liquorConsumption': 'Consumption',
  'nav.liquorStock': 'Stock',
  'nav.liquorTopSelling': 'Top Selling',
  'nav.liquorTracking': 'Liquor Tracking',
  'nav.seating': 'Seating',
  'nav.layout': 'Layout',
  'nav.designer': 'Designer',
  'nav.tableSelection': 'Table Selection',
  'nav.viewTables': 'View Tables',
  'nav.reservations': 'Reservations',
  'nav.staff': 'Staff',
  'nav.allStaff': 'All Staff List',
  'nav.staffRoles': 'Staff Roles',
  'nav.userSessions': 'User Sessions',
  'nav.settings': 'Settings',
  'nav.companyProfile': 'Company Profile',
  'nav.restaurantGroups': 'Restaurant Groups',
  'nav.locations': 'Locations',
  'nav.finderPlaces': 'Places (Near me)',
  'nav.kioskSettings': 'Kiosk Settings',
  'nav.dataDisplay': 'Data Display',
  'nav.masterData': 'Master Data',
  'nav.display': 'Display',

  // --- Settings: Data Display page -----------------------------------------
  'dataDisplay.title': 'Data Display',
  'dataDisplay.subtitle': 'Set how dates, times and default values are shown across the system.',
  'dataDisplay.dateTimeCard': 'Date & Time Format',
  'dataDisplay.dateTimeCardSubtitle': 'These settings are applied wherever a date or time is rendered.',
  'dataDisplay.timezone': 'Timezone',
  'dataDisplay.dateFormat': 'Date Format',
  'dataDisplay.timeFormat': 'Time Format',
  'dataDisplay.defaultsCard': 'Default Selections',
  'dataDisplay.defaultsCardSubtitle': 'Pick the default master values for new records and reports.',
  'dataDisplay.defaultCountry': 'Default Country',
  'dataDisplay.defaultCurrency': 'Default Currency',
  'dataDisplay.defaultLanguage': 'Default Language',
  'dataDisplay.livePreview': 'Live Preview',
  'dataDisplay.livePreviewSubtitle': 'How the current time will render with these settings.',
  'dataDisplay.date': 'Date',
  'dataDisplay.time': 'Time',
  'dataDisplay.dateAndTime': 'Date + Time',
  'dataDisplay.savePreferences': 'Save Preferences',
  'dataDisplay.placeholder.selectTimezone': 'Select timezone',
  'dataDisplay.placeholder.selectDateFormat': 'Select date format',
  'dataDisplay.placeholder.selectTimeFormat': 'Select time format',
  'dataDisplay.placeholder.selectCountry': 'Select country',
  'dataDisplay.placeholder.selectCurrency': 'Select currency',
  'dataDisplay.placeholder.selectLanguage': 'Select language',
  'dataDisplay.placeholder.selectType': 'Select type',
  'dataDisplay.loadOptionsFailed': 'Failed to load options',

  // --- Settings: Master Data page ------------------------------------------
  'masters.title': 'Master Data',
  'masters.subtitle': 'Manage shared lookup data used throughout the system.',
  'masters.tab.countries': 'Countries',
  'masters.tab.currencies': 'Currencies',
  'masters.tab.languages': 'Languages',
  'masters.tab.sectionTypes': 'Section Types',
  'masters.column.code': 'Code',
  'masters.column.name': 'Name',
  'masters.column.dialCode': 'Dial Code',
  'masters.column.symbol': 'Symbol',
  'masters.column.nativeName': 'Native Name',
  'masters.column.description': 'Description',
  'masters.searchPlaceholder': 'Search {tab}...',
  'masters.addButton': 'Add {item}',
  'masters.editTitle': 'Edit {item}',
  'masters.addTitle': 'Add {item}',
  'masters.singular.country': 'Country',
  'masters.singular.currency': 'Currency',
  'masters.singular.language': 'Language',
  'masters.singular.sectionType': 'Section Type',
  'masters.loadFailed': 'Failed to load',
  'masters.added': 'Added',
  'masters.updated': 'Updated',

  // Add / Edit Dish page - page header.
  'addDish.pageHeader.title.add': 'Add New {kind}',
  'addDish.pageHeader.title.edit': 'Edit {kind}',
  'addDish.pageHeader.description.edit': 'Update dish details, variants and attributes.',
  'addDish.pageHeader.kind.dish': 'Dish',
  'addDish.pageHeader.kind.liquor': 'Liquor',
  'addDish.pageHeader.kind.beverage': 'Beverage',
  'addDish.pageHeader.kind.addon': 'Add-on',
  'addDish.pageHeader.kind.combo': 'Combo',
  'addDish.pageHeader.backButton': 'Back to All Menu Items',
  // The marker beside the item's name in the header, and the Draft pill.
  'addDish.pageHeader.mode.editing': 'Editing',
  'addDish.pageHeader.draft': 'Draft',
  'addDish.pageHeader.sku': 'SKU',
  'addDish.pageHeader.kindLocked': 'Item type — fixed once created',
  'addDish.pageHeader.status.active': 'Active',
  'addDish.pageHeader.status.inactive': 'Inactive',
  'addDish.pageHeader.statusTitle.active': 'Currently Active — click to deactivate',
  'addDish.pageHeader.statusTitle.inactive': 'Currently Inactive — click to activate',

  // Type selector
  'addDish.typeSelector.dish.label': 'Dish',
  'addDish.typeSelector.dish.desc': 'A regular menu item',
  'addDish.typeSelector.beverage.label': 'Beverage',
  'addDish.typeSelector.beverage.desc': 'Coffee, shakes, juices, mocktails',
  'addDish.typeSelector.addon.label': 'Add-on',
  'addDish.typeSelector.addon.desc': 'Extra cheese, Nutella, topping',
  'addDish.typeSelector.combo.label': 'Combo',
  'addDish.typeSelector.combo.desc': 'Bundle existing items at a fixed price',
  'addDish.typeSelector.store_bought.label': 'Store-bought',
  'addDish.typeSelector.store_bought.desc': 'Bought outside, served as-is — cold drinks, chips',
  'addDish.typeSelector.bakery.label': 'Bakery',
  'addDish.typeSelector.bakery.desc': 'Breads, pastries, cakes',
  'addDish.typeSelector.liquor.label': 'Liquor',
  'addDish.typeSelector.liquor.desc': 'Alcoholic drinks — beer, wine, spirits',

  // Basic info card
  'addDish.basicInfo.title': 'Basic Information',
  'addDish.basicInfo.name.label': 'Name',
  'addDish.basicInfo.name.placeholder': 'e.g., Noodles',
  // Per-kind name placeholder — the example matches what's being created.
  'addDish.basicInfo.namePlaceholder.dish': 'e.g., Noodles',
  'addDish.basicInfo.namePlaceholder.liquor': 'e.g., Whisky',
  'addDish.basicInfo.namePlaceholder.beverage': 'e.g., Lemonade',
  'addDish.basicInfo.namePlaceholder.addon': 'e.g., Extra Cheese',
  'addDish.basicInfo.namePlaceholder.combo': 'e.g., Lunch Combo',
  'addDish.basicInfo.category.label': 'Category',
  'addDish.basicInfo.subcategory.label': 'Sub Category',
  'addDish.basicInfo.subcategory.placeholder': 'Select sub-category (optional)',
  'addDish.basicInfo.subcategory.empty.withCategory': 'No sub-categories under this category yet.',
  'addDish.basicInfo.subcategory.empty.noCategory': 'No sub-categories yet.',
  'addDish.basicInfo.description.label': 'Description',
  'addDish.basicInfo.description.placeholder': 'Describe the dish...',
  'addDish.basicInfo.locations.label': 'Locations',
  'addDish.basicInfo.tags.label': 'Tags',
  'addDish.basicInfo.tags.empty': 'No tags yet — create them under Settings → Masters → Tags.',
  'addDish.basicInfo.prepTime.label': 'Prep Time (mins)',
  'addDish.basicInfo.cookTime.label': 'Cook Time (mins)',
  'addDish.basicInfo.total.label': 'Total',
  'addDish.basicInfo.total.unit': 'mins',

  // Kitchen Operations card
  'addDish.kitchenOps.title': 'Kitchen Operations',
  'addDish.kitchenOps.station.label': 'Cooking Station',
  'addDish.kitchenOps.station.placeholder': 'e.g. Dosa Station, Tandoor…',
  'addDish.kitchenOps.platingNote.label': 'Plating Note',
  'addDish.kitchenOps.platingNote.placeholder': 'e.g. Serve folded…',
  'addDish.kitchenOps.servingVessel.label': 'Serving Vessel',
  'addDish.kitchenOps.servingVessel.placeholder': 'e.g. Steel Plate…',

  // Attributes card (right column)
  'addDish.attributes.title': 'Attributes',
  'addDish.attributes.spicy.label': 'Spicy',
  'addDish.attributes.spicy.less': 'Less',
  'addDish.attributes.spicy.normal': 'Normal',
  'addDish.attributes.spicy.extra': 'Extra',
  'addDish.attributes.style.label': 'Style',
  'addDish.attributes.style.dry': 'Dry',
  'addDish.attributes.style.semiGravy': 'Semi-Gravy',
  'addDish.attributes.style.gravy': 'Gravy',
  'addDish.attributes.diet.label': 'Diet',
  'addDish.attributes.diet.veg': 'Veg',
  'addDish.attributes.diet.nonveg': 'Non-Veg',
  'addDish.attributes.diet.vegan': 'Vegan',
  'addDish.attributes.nonvegType.label': 'Non-Veg Type',
  'addDish.attributes.nonvegType.empty': 'No types yet — use the + button.',
  'addDish.attributes.serve.label': 'Serve',
  'addDish.attributes.serve.hot': '☕ Hot',
  'addDish.attributes.serve.cold': '🧊 Cold',

  // Ingredients picker
  'addDish.ingredients.title': 'Ingredients',
  'addDish.ingredients.search.placeholder': 'Search ingredients…',
  'addDish.ingredients.allergenNote': 'Ones with allergens are highlighted.',
  'addDish.ingredients.allergenLabel': 'Allergens:',
  'addDish.ingredients.empty': 'No ingredients yet — use the + above to add.',

  // Garnishes picker
  'addDish.garnishes.title': 'Garnishes',
  'addDish.garnishes.search.placeholder': 'Search garnishes…',
  'addDish.garnishes.note': 'Picked from the ingredient master.',
  'addDish.garnishes.tagged': 'Tagged:',
  'addDish.garnishes.empty': 'No ingredients to pick from. Add one with the + above.',

  // Dish image card
  'addDish.dishImage.title': 'Dish Image',
  'addDish.dishImage.changeImage': 'Change Image',
  'addDish.dishImage.chooseImage': 'Choose Image',
  'addDish.dishImage.fileInfo': 'PNG, JPG up to 5MB',
  'addDish.dishImage.remove': 'Remove',

  // Take Away card
  'addDish.takeaway.title': 'Take Away',
  'addDish.takeaway.toggle.on': 'Allowed',
  'addDish.takeaway.toggle.off': 'Off',
  'addDish.takeaway.cutlery.label': 'Cutlery',
  'addDish.takeaway.cutlery.empty': 'No cutlery options — add one with the + button.',
  'addDish.takeaway.instructions.label': 'Instructions',
  'addDish.takeaway.instructions.placeholder': 'e.g. Pack sauce separately…',
  'addDish.takeaway.descField.label': 'Description',
  'addDish.takeaway.descField.placeholder': 'Short note shown to customers…',

  // Variants table
  'addDish.variants.title': 'Variants',
  'addDish.variants.subtitle': 'Add different sizes or quantities with pricing',
  'addDish.variants.addRow': 'Add Row',
  'addDish.variants.table.size': 'SIZE',
  'addDish.variants.table.unit': 'UNIT',
  'addDish.variants.table.displayName': 'DISPLAY NAME',
  'addDish.variants.table.qtyPieces': 'QTY / PIECES',
  'addDish.variants.table.serves': 'SERVES',
  'addDish.variants.table.calories': 'CALORIES',
  'addDish.variants.displayName.dish': 'Dish Name',
  'addDish.variants.displayName.custom': 'Custom…',
  'addDish.variants.displayName.customPlaceholder': 'e.g., Family Pack',
  'addDish.variants.caloriesPlaceholder': 'Kcal',
  'addDish.variants.removeTooltip.disabled': 'At least one variant is required',
  'addDish.variants.removeTooltip.enabled': 'Remove this row',
  'addDish.variants.selectSize': 'Select size',
  'addDish.variants.chooseLabel': 'Choose label',

  // Price matrix
  'addDish.priceMatrix.title': 'Price',
  'addDish.priceMatrix.description': 'Variants are columns, locations are rows. Each cell carries Normal, Take-Away and Delivery prices so a single dish can scale per branch and per channel.',
  'addDish.priceMatrix.seasonal': 'Seasonal',
  'addDish.priceMatrix.seasonalTooltip.active': 'Seasonal — every price is locked. Uncheck to enter prices.',
  'addDish.priceMatrix.seasonalTooltip.inactive': 'Mark this dish as Seasonal — locks every price cell across variants & locations.',
  'addDish.priceMatrix.seasonalLocked': 'prices locked',
  'addDish.priceMatrix.header.legend': 'Location ↓ · Variant →',
  'addDish.priceMatrix.header.cells': 'Cells: Normal · Take-Away · Delivery',
  'addDish.priceMatrix.column.base': 'BASE',
  'addDish.priceMatrix.column.seasonal': 'SEASONAL',
  'addDish.priceMatrix.column.seasonalTooltip': 'Seasonal — price set day-of for every location',
  'addDish.priceMatrix.empty': 'No locations selected for this dish yet — pick branches in the Locations card above, then price each variant per branch here.',
  'addDish.priceMatrix.price.norm': 'NORM',
  'addDish.priceMatrix.price.taway': 'T-AWAY',
  'addDish.priceMatrix.price.deliv': 'DELIV',
  'addDish.priceMatrix.placeholder.seasonal': 'Seasonal',
  'addDish.priceMatrix.tipFooter': 'Tip: leave Take-Away / Delivery blank to charge the Normal price on those channels. Toggling SEASONAL on a variant column locks every location\'s price for that variant.',

  // Recipe matrix
  'addDish.recipeMatrix.title': 'Ingredients',
  'addDish.recipeMatrix.description': 'Variants are columns, ingredients are rows. Edit any cell inline; the ×ratio shows how each variant compares to the base.',
  'addDish.recipeMatrix.header.legend': 'Variant matrix',
  'addDish.recipeMatrix.header.instructions': 'Edit any cell · ↹ to move',
  'addDish.recipeMatrix.empty': 'No ingredients in the matrix yet — pick one below to start the recipe.',
  'addDish.recipeMatrix.addRow.placeholder': '+ Add ingredient row…',
  'addDish.recipeMatrix.removeTooltip': 'Remove this ingredient from every variant',
  'addDish.recipeMatrix.noIngredientsMaster': 'No ingredients in the master yet — create them above first.',
  'addDish.recipeMatrix.allUsed': 'All available ingredients are in the matrix.',
  'addDish.recipeMatrix.tipFooter': 'Picks land in every variant — set the quantity per column.',

  // Complimentary matrix
  'addDish.complimentary.title': 'Complimentary · variant matrix',
  'addDish.complimentary.description': 'Variants are columns, complimentary items are rows. Click any cell to bundle that item free with a variant.',
  'addDish.complimentary.header.legend': 'Complimentary matrix',
  'addDish.complimentary.header.instructions': 'Click any cell to toggle',
  'addDish.complimentary.empty': 'No complimentary items in the matrix yet — pick one below to start.',
  'addDish.complimentary.add.placeholder': '+ Add complimentary item…',
  'addDish.complimentary.bundledFree': 'free',
  'addDish.complimentary.cellOnTooltip': 'Bundled free — click to remove',
  'addDish.complimentary.cellOffTooltip': 'Click to bundle free with this variant',
  'addDish.complimentary.removeTooltip': 'Remove this item from every variant',
  'addDish.complimentary.allergensIn': 'Allergens in this dish:',
  'addDish.complimentary.groupAddons': 'Add-ons',
  'addDish.complimentary.groupDishes': 'Dishes',
  'addDish.complimentary.groupBeverages': 'Beverages',
  'addDish.complimentary.groupCombos': 'Combos',
  'addDish.complimentary.noneAvailable': 'No other dishes/add-ons/beverages/combos available to bundle.',
  'addDish.complimentary.allInMatrix': 'Every available item is already in the matrix.',
  'addDish.complimentary.tipFooter': 'The picked item lands on the base variant — toggle other columns from there.',

  // Combo builder
  'addDish.comboBuilder.title': 'Combo Builder',
  'addDish.comboBuilder.description': 'Bundle existing Dish, Beverage and Add-on items at a single fixed price. Calories and allergens auto-aggregate from the picks.',
  'addDish.comboBuilder.price.label': 'Combo Price',
  'addDish.comboBuilder.price.placeholder': 'e.g. 12.50',
  'addDish.comboBuilder.price.note': 'Single fixed price charged for the whole bundle.',

  // Form actions
  'addDish.formActions.cancel': 'Cancel',
  'addDish.formActions.save': 'Save {type}',
  'addDish.formActions.update': 'Update {type}',
  'addDish.formActions.saveDraft': 'Save as Draft',
  'addDish.formActions.saving': 'Saving...',

  // Validation
  'addDish.validation.header': 'Please fix the following:',
  'addDish.validation.nameRequired': 'Dish name is required.',
  'addDish.validation.locationsRequired': 'Select at least one location.',
  'addDish.validation.liquorTypeRequired': 'Pick a liquor type (Spirit, Beer, Wine…).',
  'addDish.validation.comboEmpty': 'Combo must include at least one item (Dish, Beverage, or Add-on).',
  'addDish.validation.comboPrice': 'Combo price must be greater than 0.',
  'addDish.validation.variantDisplayName': '{row}: display name is required.',
  'addDish.validation.variantSize': '{row}: size is required.',
  'addDish.validation.variantUnit': '{row}: unit is required.',
  'addDish.validation.variantPrice': '{row}: a unit price greater than 0 is required (or mark it Seasonal).',
  'addDish.validation.addonPrice': '{row}: price must be 0 or more.',
  'addDish.validation.addonMatrixPrice': 'Add-on “{addon}”: enter a price greater than 0 for every variant.',
  'addDish.validation.baseNormalPrice': 'The base variant needs a Normal price (greater than 0) for every selected location.',
  'addDish.validation.addonDietRequired': 'Pick a diet (Veg / Non-Veg / Vegan) for this add-on.',
  'addDish.validation.pieces': '{row}: number of pieces must be at least 1.',
  'addDish.validation.variantDuplicate': 'Two variants can’t share the name “{name}”. Give each variant a unique name.',
  'addDish.validation.nameDuplicate': 'A dish named “{name}” already exists. Choose a unique name.',
  'addDish.validation.variantPrefix': 'Variant {n}',

  // Toasts
  'addDish.toast.success': 'Success',
  'addDish.toast.dishCreatedSuccess': 'Dish created successfully',
  'addDish.toast.dishUpdatedSuccess': 'Dish updated successfully',
  'addDish.toast.error': 'Error',
  'addDish.toast.failedSave': 'Failed to save dish',

  // Locations picker
  'addDish.locations.search.placeholder': 'Search branches…',
  'addDish.locations.selectAll.tooltip.allSelected': 'Deselect all branches',
  'addDish.locations.selectAll.tooltip.empty': 'Select all branches',
  'addDish.locations.empty': 'No branches yet — add them under Settings → Locations.',
  'addDish.locations.noMatches': 'No matches.',
  'addDish.locations.primary': 'PRIMARY',
  'addDish.locations.selectAllLabel': 'Select all',
  'addDish.locations.selectAllAriaLabel': 'Select all branches',

  // Recommendations picker (RecommendationPicker)
  'addDish.recPicker.search': 'Search to add…',
  'addDish.recPicker.selectedSuffix': 'selected',
  'addDish.recPicker.noMatches': 'No matches.',

  // Variant modals (still defined but matrices supersede them)
  'addDish.variantModal.pricing.title': 'Pricing — {variant}',
  'addDish.variantModal.complimentary.title': 'Complimentary Items — {variant}',
  'addDish.variantModal.recipe.title': 'Recipe — {variant}',
  'addDish.variantModal.cancel': 'Cancel',
  'addDish.variantModal.save': 'Save',
  'addDish.variantPrice.label': 'Price',
  'addDish.variantPrice.placeholder': '0.00',
  'addDish.variantPrice.seasonal': 'Seasonal — no fixed price (set day-of)',
  'addDish.variantPrice.takeawayInstructions': 'Take-Away Instructions',
  'addDish.variantPrice.takeawayPlaceholder': 'e.g. Pack sauce separately, double-wrap, keep cutlery on top…',
  'addDish.variantRecipe.empty': 'No ingredient quantities set for this variant. Add a row below.',
  'addDish.variantRecipe.ingredient.placeholder': 'Pick an ingredient',
  'addDish.variantRecipe.ingredient.allUsed': 'All ingredients used.',
  'addDish.variantRecipe.quantity.placeholder': 'Qty',
  'addDish.variantRecipe.unit.placeholder': 'g / ml / pcs',
  'addDish.variantRecipe.addRow': 'Add ingredient row',
  'addDish.variantRecipe.noIngredientsMaster': 'No ingredients in the master yet — create them from the ingredient master first.',

  // Master-create dialog (the + button on each picker opens this)
  'addDish.masterDialog.size.title': 'Add Size',
  'addDish.masterDialog.size.cta': 'Create Size',
  'addDish.masterDialog.unit.title': 'Add Unit',
  'addDish.masterDialog.unit.cta': 'Create Unit',
  'addDish.masterDialog.tag.title': 'Add Tag',
  'addDish.masterDialog.tag.cta': 'Create Tag',
  'addDish.masterDialog.category.title': 'Add Category',
  'addDish.masterDialog.category.cta': 'Create Category',
  'addDish.masterDialog.subcategory.title': 'Add Sub Category',
  'addDish.masterDialog.subcategory.cta': 'Create Sub Category',
  'addDish.masterDialog.nonveg.title': 'Add Non-Veg Type',
  'addDish.masterDialog.nonveg.cta': 'Create Non-Veg Type',
  'addDish.masterDialog.allergen.title': 'Add Allergen',
  'addDish.masterDialog.allergen.cta': 'Create Allergen',
  'addDish.masterDialog.ingredient.title': 'Add Ingredient',
  'addDish.masterDialog.ingredient.cta': 'Create Ingredient',
  'addDish.masterDialog.cookingStation.title': 'Add Cooking Station',
  'addDish.masterDialog.cookingStation.cta': 'Create Cooking Station',
  'addDish.masterDialog.platingNote.title': 'Add Plating Note',
  'addDish.masterDialog.platingNote.cta': 'Create Plating Note',
  'addDish.masterDialog.servingVessel.title': 'Add Serving Vessel',
  'addDish.masterDialog.servingVessel.cta': 'Create Serving Vessel',
  'addDish.masterDialog.cutlery.title': 'Add Take-Away Cutlery',
  'addDish.masterDialog.cutlery.cta': 'Create Take-Away Cutlery',
  'addDish.masterDialog.form.name': 'Name',
  'addDish.masterDialog.form.description': 'Description',
  'addDish.masterDialog.form.optional': 'Optional',
  'addDish.masterDialog.form.allergen': 'Allergen',
  'addDish.masterDialog.form.allergenTooltip': 'Mark this ingredient as an allergen',
  'addDish.masterDialog.form.cancel': 'Cancel',
  'addDish.masterDialog.form.submitting': 'Creating…',
  'addDish.masterDialog.validation.nameRequired': 'Name is required',
  'addDish.masterDialog.error.internal': 'Internal error',
  'addDish.masterDialog.error.noRestaurant': 'No restaurant selected',
  'addDish.masterDialog.error.noRestaurantDesc': 'Cannot create an ingredient without restaurant context.',
  'addDish.masterDialog.error.createFailed': 'Create failed',
  'addDish.masterDialog.success': 'created',
  // Prices tab: which end of the tax sum the typed prices are. {taxes} is the
  // restaurant's own tax names with rates ("VAT 15%"), never translated.
  'addDish.tax.excl': 'Price excludes tax',
  'addDish.tax.incl': 'Price includes tax',
  'addDish.tax.exclNote': 'The prices below are what you keep: {taxes} is added on top and the guest pays more.',
  'addDish.tax.inclNote': 'The prices below are what the guest pays: {taxes} is already inside them.',
  'addDish.tax.defaultNote': 'No tax picked — the default tax (Settings → Tax Rates) applies at checkout.',
  'addDish.tax.cellLine': 'net {net} · incl. tax {gross}',

  /* The crash screen. Deliberately says the app is still fine and the SCREEN
     is not: the difference decides whether somebody reloads once or gives up
     on RestoBOXX for the evening. */
  'error.title': 'This screen ran into a problem',
  'error.body': 'Nothing was lost and the rest of RestoBOXX is working. Reload this screen or go back — if it keeps happening, send the details below to support.',
  'error.details': 'What went wrong',
  'error.reload': 'Reload this screen',
  'error.back': 'Go back',
  'error.copy': 'Copy the details',
};

export default en;
